import { LeftOutlined } from '@ant-design/icons'
import { makeStyles } from '@material-ui/core'
import { Card, Descriptions, Typography } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { trackPromise } from 'react-promise-tracker'
import { useData } from '../../../../data'
import { useRouter } from '../../../../routes'
import { JobStatus } from '../../components'
import DashboardLayout, { DashboardPage } from '../../layout'


const useStyles = makeStyles(theme => ({
    cardLineItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    cardStyle: {
        borderRadius: '6px',
        boxShadow: '0px 1px 4px rgba(21, 34, 50, 0.08)',
        marginBottom: '20px',
    },
    flexHorizontal: {
        flexDirection: 'row',
    },
    root: {
        height: '100%',
        width: '100%'
    },
    top: {
        width: '100%',
        marginBottom: theme.spacing(4)
    },
    title: {
        marginBottom: 4,
        color: 'rgba(0, 0, 0, 0.45)',
        fontSize: 14
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    actions: {
        marginBottom: theme.spacing(3)
    },
    progress: {
        marginBottom: theme.spacing(3)
    }
}))

/**
 * This page contains the details of a selected job
 *
 * It shows status information of a scheduled job and provides the user with actions to run the job, check the status or run subsequent schedules
 * It also provides the user with important input and output files for download
 */

const JobTaskDetailsPage = (props) => {
    const [task, setTask] = useState(null)

    const router = useRouter()
    const classes = useStyles()
    const data = useData()
    const jobs = data.jobs()

    const { query } = router
    const taskId = query && query.id

    if (!taskId) {
        router.back()
    }

    // load the task details
    const loadTask = () => {
        if (taskId) {
            trackPromise(
                jobs.taskDetails(taskId)
                    .then((task) => {
                        setTask(task)
                    })
                    .catch(console.log)
            )
        }
    }

    // get details
    useEffect(() => {
        loadTask()
    }, [])

    const goBack = () => {
        router.history.goBack()
    }


    return (
        <DashboardLayout selected="jobs">
            <DashboardPage
                title="Job Task Details"
                hasCta={true}
                ctaIcon={<LeftOutlined />}
                buttonText="Back"
                onCtaClick={() => goBack()}
            >
                {
                    task && (
                        <div className={classes.root}>
                            <Card className={classes.cardStyle}>
                                <Descriptions title="Task details" bordered size='small'>

                                    <Descriptions.Item label="Task ID:" span={2}>
                                        <span style={{ overflowWrap: 'anywhere' }}>{task.id}</span>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Status:" span={2}>
                                        <JobStatus status={task.status} />
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Retries:" span={2}>
                                        <Typography.Text strong>
                                            <span style={{ overflowWrap: 'anywhere' }}>{task.retries}</span>
                                        </Typography.Text>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Job:" span={2}>
                                        <Typography.Text strong>
                                            {task.job_name}
                                        </Typography.Text>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Tool:" span={2}>
                                        <Typography.Text strong>
                                            <span
                                                style={{ cursor: 'pointer', overflowWrap: 'anywhere' }}
                                                onClick={() => router.push(`/dashboard/tool?id=${task.tool}`)}
                                            >
                                                {task.tool_display}
                                            </span>
                                        </Typography.Text>
                                    </Descriptions.Item>
                                    
                                    <Descriptions.Item label="Logs:" span={2}>
                                        {task.job_type == "scrapy" && 
                                            (
                                            <Typography.Text strong>
                                            <a target='_blank' href={ `${task.scrapyd_url}/logs/default/${task.spider_name}/${task.scrapyd_task_id}.log` }>{"Log file"}</a>
                                            </Typography.Text>)
                                        }
                                        
                                    </Descriptions.Item>                       
                                    <Descriptions.Item label="Created at" span={2}>{moment(task.created_at).format("YYYY-MM-DD HH:mm")}</Descriptions.Item>
                                    <Descriptions.Item label="Updated at" span={2}>{moment(task.updated_at).format("YYYY-MM-DD HH:mm")}</Descriptions.Item>
                                    <Descriptions.Item label="Task Input" span={3}>{task.inputs}</Descriptions.Item>
                                    <Descriptions.Item label="Task Errors:" span={3}>
                                        <Typography.Text strong>
                                            <span
                                                style={{ cursor: 'pointer', overflowWrap: 'anywhere', color: '#cc0000' }}
                                            >
                                                {task.errors}
                                            </span>
                                        </Typography.Text>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Celery Errors:" span={3}>
                                        <Typography.Text strong>
                                            <span
                                                style={{ cursor: 'pointer', overflowWrap: 'anywhere', color: '#cc0000' }}
                                            >
                                                {task.celery_errors}
                                            </span>
                                        </Typography.Text>
                                    </Descriptions.Item>

                                </Descriptions>
                            </Card>
                        </div>
                    )
                }
            </DashboardPage>
        </DashboardLayout>
    )
}

export default JobTaskDetailsPage;
